import { jsx as _jsx } from "react/jsx-runtime";
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { resultCategoryImages, mildCategory, } from '@/components/results-category/constants/results-category-content.constant';
import { HearingTestResult } from './hearing-results.component';
export function MildHearingLossResults() {
    useResultCategoryOutletContext({
        sideImage: resultCategoryImages.mildHearingSideImage,
        step: 3,
    });
    return _jsx(HearingTestResult, { category: mildCategory });
}
